const ERRORS = {
    SORRY: "We're sorry, there was a problem loading this page. ",
    NETWORK: "We had a problem communicating with the server, please try again. ",
    AMBASSADOR_REMOVED: "Ambassador is either archived or removed.",
    DOMAIN_EMAIL_SIGNING_UP_AS_PROSPECT:
        "This sign up form is not for staff, faculty members or student ambassadors - Wait to receive an email with further instructions.",
    INVITED_AMBASSADOR_SIGNING_UP_AS_PROSPECT:
        "This sign up form is not for staff, faculty members or student ambassadors - Please follow the instructions in the invitation email.",
    REGISTERED_AMBASSADOR_SIGNING_UP_AS_PROSPECT:
        "This sign up form is not for staff, faculty members or student ambassadors - You are a signed up ambassador. Please sign in from the ambassador dashboard.",
};

export default ERRORS;
